import api from '../utils/api';

const BUSINESS_ID = process.env.REACT_APP_BUSINESS_ID;

export const getMyAppointments = () => {
  return api.get('/appointments');
};

export const getAppointmentDetail = (appointmentId) => {
  return api.get(`/appointments/${appointmentId}`);
};

export const createAppointment = (data) => {
  return api.post('/appointments', data);
};

export const cancelAppointment = (appointmentId) => {
  return api.patch(`/appointments/${appointmentId}/cancel`);
};

export const getAvailability = (params) => {
  return api.get(`/businesses/${BUSINESS_ID}/availability`, { params });
};

/* Los endpoints de carrito reciben los servicios como services[i][service_id]
   y services[i][employee_id] (vacío = cualquiera). Se serializa a mano porque
   axios convierte objetos anidados en params a JSON. */
const appendServicesParams = (params, services) => {
  services.forEach((svc, i) => {
    params.append(`services[${i}][service_id]`, svc.serviceId);
    params.append(`services[${i}][employee_id]`, svc.employeeId ?? '');
  });
};

/* Horarios de un día para el carrito completo (cruce secuencial en el backend).
   → { date, slots: [{start, end}], total_duration_minutes } */
export const getCartAvailability = ({ date, services }) => {
  const params = new URLSearchParams();
  params.append('date', date);
  appendServicesParams(params, services);
  return api.get(`/businesses/${BUSINESS_ID}/availability?${params.toString()}`);
};

/* Días del mes con al menos un cupo para el carrito.
   → { month, available_dates: ['YYYY-MM-DD', …] } */
export const getAvailableDates = ({ month, services }) => {
  const params = new URLSearchParams();
  params.append('month', month);
  appendServicesParams(params, services);
  return api.get(`/businesses/${BUSINESS_ID}/available-dates?${params.toString()}`);
};

/* Colaboradoras capaces con al menos un hueco en la fecha.
   → { date, employees_by_service: { [serviceId]: [employeeId, …] } } */
export const getAvailableEmployees = ({ date, serviceIds }) => {
  const params = new URLSearchParams();
  params.append('date', date);
  serviceIds.forEach((id) => params.append('service_ids[]', id));
  return api.get(`/businesses/${BUSINESS_ID}/available-employees?${params.toString()}`);
};

export const createMultiServiceAppointment = ({ services, scheduled_at, notes }) => {
  const payload = {
    scheduled_at,
    notes: notes || undefined,
    services: services.map((svc) => ({
      service_id: svc.serviceId,
      employee_id: svc.employeeId || undefined,
    })),
  };
  console.log('[DEBUG] Appointment payload:', JSON.stringify(payload, null, 2));
  return createAppointment(payload);
};
